// import { DashboardOutlined, Person, Search, BusinessIcon, WorkIcon, SearchIcon, ModeStandbyIcon, CalendarMonthIcon, StorageIcon, ThumbUpIcon } from '@mui/icons-material';

//import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
// import Forum from '@mui/icons-material/Forum';
// import Analytics from '@mui/icons-material/Analytics';
// import FolderOpen from '@mui/icons-material/FolderOpen';
// import BorderColor from '@mui/icons-material/BorderColor';
//import Search from '@mui/icons-material/Search';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
//import SearchIcon from '@mui/icons-material/Search';
//import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';

import { DrawCompteEntrepriseIcons, DrawHomeIcon } from '../../../data/SVGs';
// const { i18n } = useTranslation();
const navbarListClient = [
    //{
    //    icon: Search,
    //    desc: 'Search',
    //    secondDesc: '',
    //    badge: 0,
    //    subList: [],
    //},
    {
        icon: DrawHomeIcon,
        desc: 'Tableau de bord',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'dashbordClient'
    },
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'Mon Compte',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil personnel',
                badge: 0,
                link: 'profile'
            },
            {
                desc: 'Paramètres de compte',
                badge: 0,
                link: 'parametreCompte'
            },
            //{
            //    desc: 'Messages',
            //    badge: 10,
            //    link: 'conversation'
            //},
            //{
            //    desc: 'Se déconnecter',
            //    badge: 11,
            //    link: 'deconnecter'
            //},
        ],
    },
    {
        icon: DrawCompteEntrepriseIcons,
        desc:'Compte d\'entreprise',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil entreprise',
                badge: 0,
                link: 'donneesGenerales'
            },

            {
                desc: 'Documents administratifs',
                badge: 0,
                link: 'docAdmininstratif'
            },

            {
                desc: 'Documents commerciaux',
                badge: 0,
                link: 'docCommerciaux'
            },
            {
                desc: 'Collaborateurs d\'entreprise',
                badge: 0,
                link: 'collaborators'
            },
            // {
            //     desc: 'Se déconnecter',
            //     badge: 0,
            //     link: 'logout'
            // },
        ],
    },
    {
        icon: WorkOutlineOutlinedIcon,
        desc: 'Appels d\'offres',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Créer un AO',
                badge: 0,
                link: 'createAO'
            },
            {
                desc: 'AO et candidatures',
                badge: 0,
                link: 'aos'
            },
            // {
            //     desc: 'Templates',
            //     badge: 0,
            //     link: 'template'
            // },
            {
                desc: 'Les drafts',//'Drafts',
                badge: 0,
                link: 'drafts'
            },
            //{
            //    desc: 'Mes favoris',
            //    badge: 0,
            //    link: 'favoris'
            //},
        ],
    },

    {
        icon: InsertInvitationOutlinedIcon,
        desc: 'Mes RDV',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'gestionRDV'
    },

    {
        icon: PersonSearchOutlinedIcon,
        desc: 'CVthèque',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Trouver des CV',
                badge: 0,
                // link: '',
                link:'cvTheque',
            },
            {
                desc: 'Mes dossiers',
                badge: 0,
                link: 'AllMyDossier'
            },
            // {
            //     desc: 'Mes alertes',
            //     badge: 0,
            //     link: 'cvtheque/alertes'
            // },
        ],
    },
    {
        icon: AssignmentOutlinedIcon,
        desc: 'Missions et BDC',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Propositions commerciales',
                badge: 0,
                link: 'propositionCommercial'
            },
            {
                desc: 'Les missions & Bons de commande',
                badge: 0,
                link: 'mission'
            },
        ],
    },
    {
        icon: InventoryOutlinedIcon,
        desc: 'CRA & Factures',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Compte rendu d\'activité',
                badge: 0,
                link: 'AllCras'
            },
            {
                desc: 'Factures',
                badge: 0,
                link: 'AllFactures'
            },
        ],
    },
    //hide #v2
    //{
    //    icon: DrawOutilSuiviIcons,
    //    desc: 'Outil suivi',
    //    secondDesc: '',
    //    badge: 0,
    //    subList: [
    //        /**
    //   *     <Route path="Accueil" element={<Accueil />} />
    //              <Route path="Dashboard" element={<Dashboard />} />
    //              <Route path="Tasks" element={<Tasks />} />
    //              <Route path="Ressources" element={<Ressources />} />
    //              <Route path="Notifications" element={<Notifications />} />
    //              <Route path="Collaborators" element=
    //   */
    //        {
    //            desc: 'Suivi mission',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission'
    //        },
    //        {
    //            desc: 'Accueil',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Accueil'
    //        },
    //        {
    //            desc: 'Tasks',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Tasks'
    //        },
    //        {
    //            desc: 'Ressources',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Ressources'
    //        },
    //        {
    //            desc: 'Notifications',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/Notifications'
    //        },
    //        {
    //            desc: 'Collaborateurs',
    //            badge: 0,
    //            // Must be fixed
    //            link: 'suiviMission/CollaboratorsSuiviMission'
    //        },
    //    ],
    //},
];

export const navbarListHome = [
    {
        icon: DrawHomeIcon,
        desc: 'Clients',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'homeClient'
    },
    {
        icon: DrawHomeIcon,
        desc: 'ESN',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'homeESN'
    },
    // {
    //     icon: DrawHomeIcon,
    //     desc: 'Consulting',
    //     secondDesc: '',
    //     badge: 0,
    //     subList: [],
    //     link: 'Consulting'
    // },
    {
        icon: DrawHomeIcon,
        desc: 'Experts',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'homeExpert'
    },
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'A propos',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'HTH',
                badge: 0,
                link: 'HTH'
            },
            {
                desc: 'Pourquoi HTH',
                badge: 0,
                link: 'whyHtH'
            },
            {
                desc: 'Nos formules',
                badge: 10,
                link: 'pricing'
            },
            {
                desc: 'Blog',
                badge: 11,
                link: 'blogs'
            },
        ],
    },
];

export const navbarListGlobalHome = [
    {
        icon: DrawHomeIcon,
        desc: 'Consulting',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'Consulting'
    },
    {
        icon: DrawHomeIcon,
        desc: 'Sourcing',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'Sourcing'
    },

];

export const navbarListConsultingHome = [
    {
        icon: DrawHomeIcon,
        desc: 'Nos Services',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'ConsultingServices'
    },
    {
        icon: DrawHomeIcon,
        desc: 'Blogs',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'Consultingblogs'
    },
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'A propos',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Pourquoi HTH',
                badge: 0,
                link: 'WhyHtHConsulting'
            },
            {
                desc: 'Qui sommes nous',
                badge: 0,
                link: 'AboutUsConsulting'
            },
        ],
    },
    {
        icon: DrawHomeIcon,
        desc: 'Contactez nous',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'ContactUs'
    },
];

export default navbarListClient;
